import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules'
import { onViewChange, allToTallest, allToShortest } from '@/resources/assets/js/modules/utils';

class PostsFeed {

  constructor(node) {
    if (node.nodeType !== Node.ELEMENT_NODE) return;
    this.root = node;
    this.swiper = this.root.querySelector('.PostsFeed-rail');
    this.nextEl = this.root.querySelector('.PostsFeed-pagination .next');
    this.prevEl = this.root.querySelector('.PostsFeed-pagination .prev');
    this.cardsTitle = [...this.root.querySelectorAll('.PostsFeed .CardBlog h3')];
    this.cardsIntro = [...this.root.querySelectorAll('.PostsFeed .CardBlog-body p:last-child')];

    this._init();
  }

  _init() {

    Swiper.use([Navigation, Pagination]);

    const swiper = new Swiper(this.swiper, {
      slidesPerView: 1,
      direction: 'horizontal',
      spaceBetween: 20,
      loopedSlides: 2,
      speed: 1300,
      slidesPerGroup: 1,
      loop: true,
      navigation: {
        nextEl: this.nextEl,
        prevEl: this.prevEl,
      },
      breakpoints: {
        567: {
          slidesPerView: 2,
        },
        991: {
          slidesPerView: 3,
        },
        1200: {
          slidesPerView: 4,
        },
      }
    });

    this._resizeContent();
    this._bindEvents();
  }

  _bindEvents() {
    onViewChange(this._resizeContent.bind(this));
  }

  _resizeContent() {
    setTimeout(() => {
      allToTallest(this.cardsTitle);
      allToTallest(this.cardsIntro);
    }, 100);
  }
}

[...document.querySelectorAll('.PostsFeed')].forEach(node => {
  new PostsFeed(node);
});